import InfrastructureDetailLayout from 'components/InfrastructureDetailLayout';

export default function Page() {
    return <InfrastructureDetailLayout type="road" />;
}
